import { graphql } from '@/generated/gql';

export const INTAKE_STATEMENTS_OF_WORK = graphql(/* GraphQL */ `
  query IntakeStatementsOfWork($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        statementsOfWork {
          id
          language
          text
        }
        requestDescription {
          id
          language
        }
      }
    }
  }
`);
